import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../custom/BackButton';
import ActionIcon from '../custom/ActionIcon';
import { createdUpdatedInfo } from '../../utils';
import { Manual } from '../../globals/interfaces';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    manual: Manual | undefined;
}

export default function ModalManual({
    modal,
    setModal,
    manual
}: Props) {

    const toggle = () => setModal(!modal);

    if (!manual) return null;

    return (
        <CustomModal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Manual: {manual.name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <CustomModalBody>
                <iframe
                    src={`${manual.link}#zoom=page-fit`}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="PDF Viewer"
                />
            </CustomModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(manual, true)}
                    </Label>
                </FooterContentContainer>
            </ExpandedFooter>
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    min-width: 75%;
    height: 70vh;
`;

const CustomModalBody = styled(ModalBody)`
    height: 70vh;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;